<template>
	<v-dialog v-model="dialogSwitch" persistent scrollable width="700">
		<v-form v-model="formData.valid" class="mb-3" validate-on="input lazy"
		        @submit.prevent="storeProductSKU">
			<v-card>
				<v-card-title id="heading" class="d-flex justify-space-between">
					<h4>Add Group</h4>
					<v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
				</v-card-title>
				<v-container>
					<v-alert v-if="errors.length"
					         class="mb-3 bg-error"
					         closable close-label="Close Alert"
					         density="compact" variant="tonal">
						<p v-for="error in errors">{{ error }}</p>
					</v-alert>
					<v-row>
						<v-col cols="12" sm="12">
							<v-text-field v-model="formData['label']" autofocus
							              :rules="[vRules.required, vRules.maxLength(64)]"
							              density="compact" label="Label"/>
						</v-col>
					</v-row>
				</v-container>
				<v-card-actions class="px-4 d-flex justify-end">
					<v-btn size="small" type="button"
					       @click="$emit('update:modelValue',false)">
						Close
					</v-btn>
					<v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>
<script setup>
import {reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
const snackbar = useSnackbarStore();
const props = defineProps({
	modelValue: Boolean,
});
const formData = reactive({
	valid: false,
	label: null,
});
const emits = defineEmits(['update:modelValue', 'addDeviceGroup']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);
const storeProductSKU = () => {
	errors.value = [];
    send('post', `device-groups`, formData)
        .then((response) => {
			snackbar.showSnackbar(response.data.message);
			if (response.data.success) {
				emits('addDeviceGroup', response.data.data.device_group);
				emits('update:modelValue', false);
			}
		})
		.catch(function (errorResponse) {
			if (errorResponse.response.data.errors) {
				let validationErrors = errorResponse.response.data.errors;
				Object.keys(validationErrors).forEach((key) => {
					errors.value.push(validationErrors[key][0]);
				});
			} else if (errorResponse.response.data.message) {
				errors.value.push(errorResponse.response.data.message);
			}
			snackbar.showSnackbar('Something went wrong', 'error');
			document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
		})
}
</script>
